// generic

<template>
  	<v-container fluid pa-0 ma-0>
		<v-row>
		<v-col>
			<v-card tile width="1200">
				<v-toolbar dense flat color="blue-grey darken-3">
					<v-btn ripple icon @click="$router.back()"><v-icon color="black">mdi-arrow-left-bold-box</v-icon></v-btn>
					<v-text-field flat solo dense hide-details background-color="blue-grey darken-3" :prefix="prefix" readonly
						:value="item.name"
					></v-text-field>  
					<v-spacer />
					<v-hover v-slot:default="{ hover }">
					<v-btn small fab color="grey darken-3" :class="{ 'success': hover }" @click.stop="onEdit()" :loading="false" :disabled="false">
					<v-icon>create</v-icon></v-btn></v-hover>
					<v-hover v-if="cfgTable.hasspec" v-slot:default="{ hover }">
					<v-btn small fab color="grey darken-3" :class="{ 'warning': hover }" @click.stop="onSpec()" :loading="false" :disabled="false">
					<v-icon>assignment</v-icon></v-btn></v-hover>
					<v-hover v-slot:default="{ hover }">
					<v-btn small fab color="grey darken-3" :class="{ 'primary': hover }" @click.stop="onPrint(item.id)" :loading="false" :disabled="false">
					<v-icon>print</v-icon></v-btn></v-hover>
					<v-btn disabled plain small>ID: {{ item.id }}</v-btn>
					<v-btn ripple icon><v-icon color="yellow darken-3">mdi-star</v-icon></v-btn>
				</v-toolbar>
				<v-tabs v-model="htab" background-color="blue-grey darken-3" color="grey" active-class="blue-grey darken-1 black--text"
					align-with-title
					slider-color="blue-grey darken-1"
					dark dense height="35px"
					next-icon="mdi-arrow-right-bold-box-outline"
					prev-icon="mdi-arrow-left-bold-box-outline"
					show-arrows show-arrows-on-hover center-active
				>
					<v-tab v-for="(item, hindex) in cfgRefTables" :key="hindex">
						{{ tabname(item, hindex) }}
					</v-tab>
				</v-tabs>
				<v-tabs-items v-model="htab">
					<v-tab-item v-for="(item, hindex) in cfgRefTables" :key="hindex" class="secondary">
						<GenericItem v-if="genericItemModul(hindex)"
							:modulData="modulData(hindex)" />
						<GenericSubList v-if="genericSubListModul(hindex)"
							:modulData="modulData(hindex)" @updated="onSubListUpdate()" />
						<GenericDocList v-if="genericDocListModul(hindex)"
							:modulData="modulData(hindex)" @updated="onDocListUpdate()" />
						<GenericOverview v-if="genericOverviewModul(hindex)"
							:modulData="modulData(hindex)" />
					</v-tab-item>
				</v-tabs-items>
			</v-card>
		</v-col>
		</v-row>
    	<GenericForm v-if="edit" :modulData="modulData()" @cancelled="editCancelled()" @submitted="editSubmitted()" />
    	<GenericAction v-if="action" :modulData="modulData()" @cancelled="actionCancelled()" />
    	<SpecialComponent v-if="special" :modulData="modulData()" @cancelled="specialCancelled()" />
    	<v-snackbar v-model="snack.active" :color="snack.type"> {{ snack.text }}
      		<v-btn text dark @click="snack.active = false">Ok</v-btn>
    	</v-snackbar>
        <v-overlay absolute :value="loading">
        	<v-progress-circular indeterminate size="64" width="7" color="cyan darken-4"></v-progress-circular>
        </v-overlay>
	</v-container>
</template>
<script>
import GenericItem from './GenericItem'
import GenericForm from './GenericForm'
import GenericAction from './GenericAction'
import GenericSubList from './GenericSubList'
import GenericDocList from './GenericDocList'
import GenericOverview from './GenericOverview'
import SpecialComponent from '../special'
export default {
	name: 'GenericView',
	components: {
		GenericItem, GenericForm, GenericSubList, GenericDocList, GenericAction, GenericOverview, SpecialComponent,
	},
	props: {
		routeData: {
			type: Object,
			required: true,
			default: null,
		},
	},
	data: () => ({
		search: '',
		cfgTable: {},
		cfgRefTables: [],
		htab: 0,
		item: {},
		edit: false,
		action: false,
		special: false,
		snack: { active: false, type: 'success', text: 'saved', },
	}),
	computed: {
		prefix() {
			if(!this.cfgTable) return ''
			return this.cfgTable.model_title + ':'
		},
	},
	methods: {
		modulData(tabindex = 0) {
			if(!this.routeData) return null
			const modulData = Object.assign({}, this.routeData)
			modulData.meta.item = this.item
			modulData.meta.model = this.item
			modulData.meta.subtable = this.cfgRefTables[tabindex].table_name
			modulData.meta.viewtable = this.cfgTable.overview
			modulData.meta.subviewtable = this.cfgTable.suboverview
			return modulData
		},
		async getData() {
			this.loading = true
			const param = {
				tablename: this.routeData.meta.tablename,
				data: this.routeData.params,
			}
            try {
                await this.$store.dispatch('generic/getItem', param)
                const result = this.$store.getters['generic/getItem']
                this.item = Object.assign({}, result)
				//console.log('item:', this.item)
            } catch (error) {
                console.error(error)
                this.message.title = error.name
                this.message.msg = '<code>' + JSON.stringify(error.message).substring(0, 200) + '</code>'
                this.showmessage = true
            } finally {
                this.loading = false
            }
		},
		genericItemModul(tabindex) {
			if(!this.item.id) return false
			if(this.cfgRefTables[tabindex].table_name==this.routeData.meta.tablename) return true
			return false
		},
		genericSubListModul(tabindex) {
			//console.log('list?', this.htab, tabindex, this.cfgRefTables[tabindex].table_name, this.routeData.meta.tablename)
			if(!this.item.id) return false
			if(this.htab != tabindex) return false
			if(this.cfgRefTables[tabindex].table_name == 'documents') return false
			if(this.cfgRefTables[tabindex].table_name == this.cfgTable.overview) return false
			if(this.cfgRefTables[tabindex].table_name != this.routeData.meta.tablename) return true
			return false
		},
		genericDocListModul(tabindex) {
			//console.log('list?', this.htab, tabindex, this.cfgRefTables[tabindex].table_name, this.routeData.meta.tablename)
			if(!this.item.id) return false
			if(this.htab != tabindex) return false
			if(this.cfgRefTables[tabindex].table_name != 'documents') return false
			if(this.cfgRefTables[tabindex].table_name != this.routeData.meta.tablename) return true
			return false
		},
		genericOverviewModul(tabindex) {
			if(!this.item.id) return false
			if(this.htab != tabindex) return false
			if(this.cfgRefTables[tabindex].table_name != this.cfgTable.overview) return false
			if(this.cfgRefTables[tabindex].table_name != this.routeData.meta.tablename) return true
			return false
		},
		onEdit(){
			this.edit = true
		},
		onSpec(){
			this.special = true
		},
		specialCancelled () {
			this.getData()
			this.special = false
		},
		actionCancelled () {
			this.getData()
			this.action = false
		},
		editCancelled () {
			this.edit = false
			this.snack = {active: true, type: 'warning', text: 'cancelled'}
		},
		editSubmitted() {
			this.getData()
			this.edit = false
			this.snack = {active: true, type: 'success', text: 'saved'}
		},
		onSubListUpdate() {
			//console.log('sublist updated')
			this.getData()
		},
		onDocListUpdate() {
			console.log('doclist updated')
			this.getData()
		},
		onSearch(){
			
		},
		onSearchClear(){
			
		},
		onPrint(id) {
			this.action = true
			return
			const url = new URL(window.location.origin)
			const baseURL = url.protocol + '//' + url.hostname
			const path = baseURL + '/' + this.cfgTable.model_name + '/' + id + '/print'
			//console.log('path:', path)
			window.open(path, "_blank")
		},
		getCfgs() {
			const param = {
				table_name: this.routeData.meta.tablename,
			}
			this.cfgTable = this.$store.getters['core/getCfgTable'](param)
			this.cfgRefTables = this.$store.getters['core/getCfgRefTables'](param)
			if(this.cfgTable.overview) {
				this.cfgRefTables.push({ table_name: this.cfgTable.overview, table_title: 'Auswertung' })
			}
		},
		tabname(item, hindex) {
			if(!hindex && item.model_title) return item.model_title
			if(item.table_title) return item.table_title
			return item.table_name
		},
	},
	beforeMount() {
		this.getCfgs()
		this.getData()
	},
};
</script>
<style scoped>
div >>> .v-text-field__prefix {
    color: rgba(255, 255, 255, 0.3);
}
</style>